import { faHouse } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Helmet } from 'react-helmet-async';

import type { IContainerProps } from '~/components/utils/Container';
import { QuerySkeleton } from '~/components/atoms/QuerySkeleton';
import { Breadcrumbs } from '~/components/molecules/Breadcrumbs';
import { useAppQuery } from '~/lib/api/modules/Apps/hooks/useAppQuery';
import { useCategoriesQuery } from '~/lib/api/modules/Categories/hooks/useCategoriesQuery';

export type ICategoryBreadcrumbsProps = IContainerProps & {
  children?: React.ReactNode;
  appId: string;
  categoryId?: string;
  includeSelf?: boolean;
};

export const CategoryBreadcrumbs: React.FC<ICategoryBreadcrumbsProps> = (
  props,
) => {
  const { sx, children, appId, categoryId, includeSelf } = props;
  const appQuery = useAppQuery({ appId });
  const categoriesQuery = useCategoriesQuery({ appId });

  const currentCategory = categoriesQuery.data?.categories?.find(
    (category) => category._id === categoryId,
  );
  const parentCategory =
    currentCategory &&
    (includeSelf
      ? currentCategory
      : categoriesQuery.data?.categories?.find(
          (category) => category._id === currentCategory.parentId,
        ));

  const pageTite = currentCategory?.name;

  return (
    <>
      {pageTite ? (
        <Helmet>
          <title>{pageTite}</title>
        </Helmet>
      ) : null}

      <Breadcrumbs sx={sx}>
        <Breadcrumbs.Action href={`/apps/${appId}/content`}>
          <FontAwesomeIcon icon={faHouse} />
          <QuerySkeleton query={appQuery} length={{ min: 8, max: 16 }}>
            {appQuery.data?.name}
          </QuerySkeleton>
        </Breadcrumbs.Action>
        {parentCategory ? (
          <Breadcrumbs.Action
            href={`/apps/${appId}/categories/${parentCategory._id}`}
          >
            <QuerySkeleton query={categoriesQuery} length={{ min: 8, max: 16 }}>
              {parentCategory.name}
            </QuerySkeleton>
          </Breadcrumbs.Action>
        ) : null}
        {children && <Breadcrumbs.Text current>{children}</Breadcrumbs.Text>}
      </Breadcrumbs>
    </>
  );
};
